import { toast } from 'vue3-toastify';
import { useUserStore } from "@/vue/store/userStore";

window.onload=function() {
    if( window.Echo ) {
        let userStore = useUserStore();

        const wait = new Promise((resolve, reject) => {
            const loop = () => userStore.user !== undefined ? resolve(userStore.user) : setTimeout(loop)
            loop();
        });

        wait.then((user) => {
            subscribeOrgMessage(user.id, user.staff.org_id);
        });
    }
}

function subscribeOrgMessage(user_id, org_id) {
    console.info("Socket> user_id "+ user_id +" connecting to Org channel: org-message."+ org_id);

    window.Echo.private('org-message.'+ org_id)
        .listen('.org.message.delivery', (e) => {
            if( e.payload.user_id === user_id ) {
                let msg = "<b> WEB SERVER:</b> <u>" + window.hostname +"</u>\n"
                    + "<b>ORIGIN SERVER:</b> <u>" + e.payload.hostname +"</u>\n"
                    + "<b>EVENT SERVER:</b> <u>" + e.hostname +"</u>\n"
                    + e.payload.message;
                toast.success(msg, {dangerouslyHTMLString: true});
            }
        });

    // Disconnect after 30 minutes of idle (session is 20 minutes in Prod, 120 in Dev and Stage)
    setTimeout(function() {
        window.Echo.leaveChannel('private-org-message.'+ org_id);
        console.info("Socket> user_id "+ user_id +" disconnected from Org channel: org-message."+ org_id);
    }, 30 * 60 * 1000);
}
